export default __webpack_public_path__ + "static/media/custom_mug.b75463ba.jpg";